export default __webpack_public_path__ + "static/media/22.04196343.jpg";